/**
 * Format a cent amount as a money string using the given currency/locale,
 * replacing the locale's currency symbol with symbolOverride.
 *
 * Uses formatToParts and collects ALL integer + group parts so that
 * thousands separators are preserved (e.g. "1,234.56" not "1.56").
 */
export function formatMoney(
  cents: number,
  currency: string,
  locale: string,
  symbolOverride: string,
): string {
  const amount = cents / 100;
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const parts = formatter.formatToParts(amount);
  const integer = parts
    .filter((p) => p.type === 'integer' || p.type === 'group')
    .map((p) => p.value)
    .join('');
  const decimal = parts.find((p) => p.type === 'decimal')?.value ?? '.';
  const fraction = parts.find((p) => p.type === 'fraction')?.value ?? '00';
  return `${symbolOverride}${integer}${decimal}${fraction}`;
}
